const wowApp = require('angular').module('wowApp.auth');

wowApp.service('ShopperService', ['Restangular', 'BootstrapService', 'ShopperAnalyticsService', require('./shopper.service')]);
wowApp.service('ShopperAnalyticsService', ['AnalyticsService', require('./analytics/shopper-analytics.service')]);
wowApp.directive('wowShopperAccessibility', ['Restangular', 'ShopperService', require('./shopperaccessibility.directive')]);



// WEBPACK FOOTER //
// ./src/auth/shopper/index.js